import * as React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, ThemeProvider } from '@mui/material';
import { getIcon } from '../../../helper/getIcon';
import { colors } from '../../../theme/color-palette';
import { makeStyles } from '@material-ui/core/styles';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { tileStyles } from './styles';
import { convertToInternationalCurrencySystem } from '../../../helper/convertAmount';
import { theme } from '../../../theme/theme';
import { performanceSummary } from '../../../constants/constant';
import { removeNegativeSignFromNumValues } from '../../../helper/commonUtils'

const useStyles = makeStyles(tileStyles);

const Tiles = ({
	share,
	netSales,
	shareChg,
	wmValue,
	netSalesAbsChg,
	netSalesPercentChg,
	title,
	comparisonSection,
}) => {
	const {
		name, // Category || Department || Subcategory Name
	} = useParams();
	const classes = useStyles();
	const sign = share ? 'bps' : '%';

	const change = shareChg > 0 ? 1 : -1;
	const percentChg = netSalesPercentChg > 0 ? 1 : -1;
	const absChg = convertToInternationalCurrencySystem(netSalesAbsChg);

	return (
		<ThemeProvider theme={theme}>
			<Box className={classes.card}>
				<Box className={classes.cardContent}>
					<Typography className={classes.subtitle}>{title}</Typography>
					<Box>
						{share ? (
							<Typography variant="bold" className={classes.mainValue}>
								{share}%
							</Typography>
						) : (
							<Typography variant="bold" className={classes.mainValue}>
								{netSales}
							</Typography>
						)}
					</Box>
					{comparisonSection && (
						<Box className={classes.comparisonSection}>
							<Box className={classes.columnOne}>
								<Typography variant="body2" className={classes.comparisonText}>
									{performanceSummary.VS_PREVIOUS_PRD}
								</Typography>
							</Box>
							{share ? (
								<Box className={classes.columnTwo}>
									<Typography
										variant="bold"
										className={classes.changeText}
										sx={{
											color:
												change < 0 ? colors.ERROR_MD : colors.SUCCESS_MD,
										}}>
										<span className={classes.icon}>{getIcon(change)}</span>
										{removeNegativeSignFromNumValues(shareChg)} {sign}
									</Typography>
								</Box>
							) : (
								<Box className={classes.columnTwo}>
									<Typography
										variant="bold"
										className={classes.changeText}
										sx={{
											color: colors.MAKO,
										}}>
										{absChg}
									</Typography>
								</Box>
							)}
							{netSalesPercentChg && (
								<Box className={classes.columnThree}>
									<Typography
										variant="bold"
										className={classes.changeText}
										sx={{
											color:
												percentChg < 0 ? colors.ERROR_MD : colors.SUCCESS_MD,
										}}>
										<span className={classes.icon}>{getIcon(percentChg)}</span>
										{removeNegativeSignFromNumValues(netSalesPercentChg)}%
									</Typography>
								</Box>
							)}
						</Box>
					)}
					{wmValue && (
						<Box className={classes.comparisonSection} mt={1}>
							<Box className={classes.columnOne}>
								<Typography variant="body2" className={classes.detailText}>
									{performanceSummary.WMT} {name?.toLocaleLowerCase()}
								</Typography>
							</Box>

							<Box className={classes.columnThree}>
								<Typography
									variant="bold"
									className={classes.changeText}
									sx={{
										color: wmValue < 0 ? colors.ERROR_MD : colors.SUCCESS_MD,
									}}>
									<span className={classes.icon}>{getIcon(wmValue)}</span>
									{removeNegativeSignFromNumValues(wmValue)}
									{'%'}
								</Typography>
							</Box>
						</Box>
					)}
				</Box>
			</Box>
		</ThemeProvider>
	);
};

Tiles.propTypes = {
	title: PropTypes.string,
	share: PropTypes.any,
	netSales: PropTypes.any,
	shareChg: PropTypes.any,
	wmValue: PropTypes.any,
	netSalesAbsChg: PropTypes.any,
	netSalesPercentChg: PropTypes.any,
	comparisonSection: PropTypes.boolean,
};

export default Tiles;
